// components/Seo.js
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Seo = ({
  title,
  description,
  keywords,
  image = "/songjukti_logo.png",
  url = "https://www.songjukti.com",
}) => {
  const fullTitle = title
    ? `${title} | Songjukti`
    : "Songjukti | Bangladesh's Fastest Growing Freelancer Marketplace";
  const metaDescription =
    description ||
    "Songjukti is Bangladesh’s fastest-growing freelancer marketplace — hire verified professionals, discover remote jobs, and collaborate with trusted agencies for design, development, writing, marketing, and more.";
  const metaKeywords =
    keywords ||
    "Songjukti, freelancer Bangladesh, hire freelancers, online marketplace Bangladesh, remote jobs, agencies, creative professionals";

  return (
    <HelmetProvider>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={url} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={image} />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@songjukti" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={image} />
      </Helmet>
    </HelmetProvider>
  );
};

export default Seo;

